// extracted by mini-css-extract-plugin
export default {"root":"SupportStaffLogin_root__nIpJw","is-loading":"SupportStaffLogin_is-loading__31Slq"};